import { create } from 'zustand';

interface LoadingState {
  isLoading: boolean;
  setLoading: (loading: boolean, minDuration?: number) => void;
}

interface OperatorsState {
  operators: string[];
  setOperators: (operators: string[]) => void;
  selectedOperator: string;
  setSelectedOperator: (selectedOperator: string) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  setLoading: (loading, minDuration = 0) => {
    if (loading) {
      set({ isLoading: true });
    } else {
      setTimeout(() => set({ isLoading: false }), minDuration);
    }
  },
}));

export const useOperatorsStore = create<OperatorsState>((set) => ({
  selectedOperator: '',
  setSelectedOperator: (selectedOperator) => {
    if (selectedOperator) {
      set({ selectedOperator });
    }
  },
  operators: [],
  setOperators: (operators) => {
    if (operators) {
      set({ operators });
    }
  },
}));
